<div class="success">

  <h1>{{ t('orderPlacedSuccessTitle') }}</h1>
  <p>{{ t('orderOnTheWay') }}</p>

  <a routerLink="/" class="btn">{{ t('backToHome') }}</a>

</div>
